import { getLocale } from "../runtime";

const sv_plcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Polen`
};

const plcountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_plcountry(inputs)
	return "plCountry";
};

export { plcountry as "plCountry" };